import { useSelector } from 'react-redux';
import { get } from '../Services/http';
import React, { Fragment, useState, useEffect } from 'react';
import { translate } from '../Services/translation';
import Loader from './Loader';

export const AffiliateStock = ({ variantId }) => {
    const [showLoader, setShowLoader] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [affiliateStock, setAffiliateStock] = useState([]);

    const affiliates = useSelector((state) => state.affiliates);
    const selectedAffiliate = affiliates.find((x) => x.selected === true);

    useEffect(() => {
        setAffiliateStock([]);
        setIsOpen(false);
    }, [selectedAffiliate]);

    const GetStock = () => {
        if (affiliateStock.length > 0) {
            setAffiliateStock([]);
            setIsOpen(!isOpen);
        } else {
            if (selectedAffiliate) {
                setShowLoader(true);
                get(
                    '/api/affiliateStock?affiliateId=' +
                        selectedAffiliate.id +
                        '&variantId=' +
                        variantId
                )
                    .then((response) => response.json())
                    .then((result) => {
                        setAffiliateStock(result);
                        setShowLoader(false);
                        setIsOpen(!isOpen);
                    })
                    .catch((ex) => console.log(ex));
            }
        }
    };

    const arrowIconClass = isOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down';
    return (
        <Fragment>
            <div className="product-detail__affiliate-stock" onClick={GetStock}>
                <span>{translate('code.product.affiliate.get.stock')}</span>{' '}
                <i className={arrowIconClass}></i>
            </div>
            {isOpen && (
                <ul>
                    {affiliateStock.map((affiliate, i) => {
                        const stockStatusIconClass =
                            affiliate.quantity > 0
                                ? 'fa fa-circle-check'
                                : 'fa fa-circle';
                        const stockStatusCssClass =
                            affiliate.quantity > 0
                                ? 'product-detail__stock-status--in-stock'
                                : 'product-detail__stock-status--out-of-stock';
                        return (
                            <li key={i}>
                                <p className={stockStatusCssClass}>
                                    <i className={stockStatusIconClass}></i>{' '}
                                    {affiliate.quantity}{' '}
                                    {translate(
                                        'code.product.affiliate.stockmessage'
                                    )}{' '}
                                    {affiliate.name}
                                </p>
                            </li>
                        );
                    })}
                </ul>
            )}

            {showLoader && (
                <div className="product-detail__affiliate-stock--loader">
                    <Loader />
                </div>
            )}
            <div className="product-detail__separator"></div>
        </Fragment>
    );
};

export default AffiliateStock;
